import React from 'react';
import {
  IconBarrons,
  IconDjRiskJournal,
  IconDowjones,
  IconDragonfly,
  IconFnlondon,
  IconIbd,
  IconMansionglobal,
  IconMarketwatch,
  IconOpis,
  IconOxan,
  IconPen,
  IconWsj,
  IconWsjChina,
  IconWsjcommerce,
  IconWsjJapan,
  IconWsjopinion,
  IconWsjPro,
  IconYdj
} from '@screentone/core';

import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { IconNewswires, IconOpinionFreeExpression, IconPrivateMarket } from './customBrandIcons';
import { isCwsjVideo, isOpinion } from './TypeAndBrandToken';

export type BrandIconProps = {
  product: string | null | undefined;
  publicationMap: Record<string, string> | undefined;
  allessehContent?: AllessehContent;
};

export const brandIcon = ({ allessehContent, product, publicationMap }: BrandIconProps) => {
  let mappedBrand = '';

  if (allessehContent && isCwsjVideo(allessehContent) && product) {
    mappedBrand = publicationMap?.['WSJ S Chinese'] ?? product;
  } else if (allessehContent && isOpinion(allessehContent) && product) {
    mappedBrand = publicationMap?.Opinion ?? product;
  } else if (product) {
    mappedBrand = publicationMap?.[product] ?? product;
  }

  type IconType = React.ComponentType<{ size: string }>;

  switch (mappedBrand) {
    case 'barrons':
    case 'penta':
      return IconBarrons as IconType;
    case 'wsj':
      return IconWsj as IconType;
    case 'marketwatch':
      return IconMarketwatch as IconType;
    case 'pen':
      return IconPen as IconType;
    case 'fnlondon':
      return IconFnlondon as IconType;
    case 'mansionglobal':
      return IconMansionglobal as IconType;
    case 'jwsj':
      return IconWsjJapan as IconType;
    case 'cwsj':
      return IconWsjChina as IconType;
    case 'opinion':
    case 'wsjopinion':
      return IconWsjopinion as IconType;
    case 'wsjcommerce':
      return IconWsjcommerce as IconType;
    case 'ydj':
      return IconYdj as IconType;
    case 'djriskjournal':
      return IconDjRiskJournal as IconType;
    case 'oxan':
      return IconOxan as IconType;
    case 'newswires':
      return IconNewswires as IconType;
    case 'dragonfly':
      return IconDragonfly as IconType;
    case 'privatemarket':
      return IconPrivateMarket as IconType;
    case 'wsjopinionfreeexpression':
      return IconOpinionFreeExpression as IconType;
    case 'ibd':
      return IconIbd as IconType;
    case 'wsjpro':
      return IconWsjPro as IconType;
    case 'energynews':
      // TODO: Temporary
      return IconDowjones as IconType;
    case 'opis':
      return IconOpis as IconType;
    default:
      return undefined;
  }
};
